import React, { useState, useEffect, useRef } from "react";

import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getAppCurrencyType } from "../../../../../Utils/Common";

import { ProjectTenderDetailInterface } from "../../../../../Controllers/Types/Tender/projectTenderDetailsInterface";
import { Priliminary, SowSection, SowSectionItemData, SowSubSectionItemData } from "../../../../../Controllers/Types/Tender/tenderSow";
import { formatPrice } from "../../../../../Utils/getDate";

interface DownloadSowProps {
    isOpen: boolean;
    onClose: () => void;
    coverPageDesc: string;
    projectTenderDetailInterface: ProjectTenderDetailInterface;
    sowSection: SowSection[];
    sowPriliminary: Priliminary[];
}

const DownloadSOW: React.FC<DownloadSowProps> = ({
    isOpen,
    onClose,
    coverPageDesc,
    projectTenderDetailInterface,
    sowSection,
    sowPriliminary,
}) => {

    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const currencySymbol = getAppCurrencyType();

    const handleDownloadSowDocument = () => {

    }

    const downloadSowModalHeader = (
        <div className="full_view_modal_header_inner">
            <h6 className="date_text">
                DATE : {getCurrentDate()}
            </h6>
            <h5>Schedule of work</h5>
            <div className="modal_btn_area">
                <button type="button" className="download_btn p-ripple"
                    onClick={handleDownloadSowDocument}>
                    <i className="bi bi-download"></i>
                    <Ripple />
                </button>

                <button type="button" className="close_modal_btn dark p-ripple"
                    onClick={onClose}>
                    <i className="bi bi-x-circle-fill"></i>
                    <Ripple />
                </button>
            </div>
        </div>
    )


    const getRowClassName = () => {
        return 'project_table_row';
    };

    return (
        <Dialog header={downloadSowModalHeader} headerClassName="full_view_modal_header" draggable={false}
            visible={isOpen} className="custom_modal_dialog modal_dialog_full" onHide={onClose} contentClassName="pt-2 pt-sm-2">
            <div className="custom_modal_body with_responsive" id="exportDocument">
                <article className="main_section_area view_only d-flex" style={{ minHeight: '60vh' }}>
                    <div className="cover_page_area">
                        <h2>Schedule of work</h2>
                        <h6>{coverPageDesc}</h6>
                        <h5>At</h5>
                        <h5>{projectTenderDetailInterface.project_address}</h5>
                        <br />
                        <h5>For <br />{projectTenderDetailInterface.company_name}</h5>
                    </div>
                </article>

                {sowSection?.length > 0 && (
                    <article id="content" className="main_section_area view_only">
                        <div className="main_section_header">
                            <h6>Contents</h6>
                        </div>

                        <DataTable
                            value={sowSection}
                            size="small"
                            tableStyle={{ minWidth: '50rem' }}
                            className="page_table project_table view_only p-0 p-sm-2"
                            tableClassName="mb-1"
                            rowClassName={getRowClassName}
                            scrollable
                            scrollHeight={'75vh'}
                            emptyMessage="No data found"
                        >
                            <Column
                                header="Section no"
                                alignHeader={'center'}
                                body={(rowData: SowSection) => rowData.section_no ? <span className="flex_center">{rowData.section_no}</span> : '--'}
                                style={{ width: '15%' }}
                                className="table_column"
                            ></Column>
                            <Column
                                header="Content"
                                body={(rowData: SowSection) => rowData.section_name ? <span>{rowData.section_name}</span> : '--'}
                                style={{ width: '65%' }}
                                className="table_column"
                            ></Column>
                            <Column
                                header="Price"
                                alignHeader={'right'}
                                body={(rowData: SowSection) => rowData.section_amount !== null ?
                                    <span className="flex-end text-end text_no_wrap">
                                        {currencySymbol}&nbsp;{formatPrice(rowData.section_amount!)}
                                    </span> : '--'}
                                style={{ width: '20%' }}
                                className="table_column text-end"
                            ></Column>
                        </DataTable>
                    </article>
                )}

                {sowSection.map((section) => (
                    <React.Fragment>
                        {section?.sub_section_data?.length !== 0 && (
                            <React.Fragment>
                                <article id={`section${section?.section_no}`} key={section.section_id} className="main_section_area view_only">
                                    <div className="main_section_header">
                                        <h6>{section?.section_no}. {section?.section_name}</h6>
                                    </div>
                                    <DataTable
                                        value={section?.sub_section_data}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table view_only p-0 p-sm-2"
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                    >
                                        <Column
                                            header="Sub section no."
                                            alignHeader={'center'}
                                            body={(rowData) => rowData.sub_section_no ? <span className="flex_center">{rowData.sub_section_no}</span> : '--'}
                                            style={{ width: '15%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Sub section name"
                                            body={(rowData) => rowData.sub_section_name ? <span>{rowData.sub_section_name}</span> : '--'}
                                            style={{ width: '65%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Price"
                                            alignHeader={'right'}
                                            body={(rowData) => rowData.sub_section_amount !== null ?
                                                <span className="flex-end text-end text_no_wrap">
                                                    {currencySymbol}&nbsp;{formatPrice(rowData.sub_section_amount)}
                                                </span> : '--'}
                                            style={{ width: '20%' }}
                                            className="table_column text-end"
                                        ></Column>
                                    </DataTable>
                                </article>

                                {section.sub_section_data?.map((subSection) => (
                                    <React.Fragment>
                                        {subSection.sub_section_item_data?.length !== 0 && (
                                            <article id={`subsection${subSection?.sub_section_no}`} key={section.section_id} className="main_section_area view_only">
                                                <div className="main_section_header">
                                                    <h6>Section {section?.section_no} ({subSection?.sub_section_no + ' ' + subSection?.sub_section_name}) </h6>
                                                </div>

                                                <DataTable
                                                    value={subSection.sub_section_item_data}
                                                    size="small"
                                                    tableStyle={{ minWidth: '50rem' }}
                                                    className="page_table project_table view_only p-0 p-sm-2"
                                                    tableClassName="mb-1"
                                                    rowClassName={getRowClassName}
                                                    scrollable
                                                    scrollHeight={'75vh'}
                                                    emptyMessage="No data found"
                                                >
                                                    <Column
                                                        header="Item no."
                                                        alignHeader={'center'}
                                                        body={(rowData: SowSubSectionItemData) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                                        style={{ width: '8%' }}
                                                        className="table_column"
                                                    ></Column>

                                                    <Column
                                                        header="Item name"
                                                        body={(rowData: SowSubSectionItemData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                                        style={{ width: '30%' }}
                                                        className="table_column"
                                                    ></Column>

                                                    <Column
                                                        header="Unit no."
                                                        body={(rowData: SowSubSectionItemData) => rowData.item_amount_data?.unit_no ? <span>{rowData.item_amount_data?.unit_no}</span> : '--'}
                                                        alignHeader={'center'}
                                                        style={{ width: '10%' }}
                                                        className="table_column"
                                                    ></Column>

                                                    <Column
                                                        header="Unit price"
                                                        body={(rowData: SowSubSectionItemData) => rowData.item_amount_data?.unit_price ? <span>{formatPrice(rowData.item_amount_data?.unit_price)}</span> : '--'}
                                                        alignHeader={'right'}
                                                        style={{ width: '12%' }}
                                                        className="table_column text-end"
                                                    ></Column>

                                                    <Column
                                                        header="Sub total"
                                                        body={(rowData: SowSubSectionItemData) => rowData.item_amount_data?.total ? <span>{formatPrice(rowData.item_amount_data?.total)}</span> : '--'}
                                                        alignHeader={'right'}
                                                        style={{ width: '12%' }}
                                                        className="table_column text-end"
                                                    ></Column>

                                                    <Column
                                                        header="Note"
                                                        body={(rowData: SowSubSectionItemData) => rowData.item_amount_data?.note ? <span>{rowData.item_amount_data?.note}</span> : '--'}
                                                        alignHeader={'center'}
                                                        style={{ width: '28%' }}
                                                        className="table_column"
                                                    ></Column>
                                                </DataTable>
                                            </article>
                                        )}
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        )}

                        {section?.section_item_data?.length !== 0 && (
                            <article id={`section${section?.section_no}`} key={section.section_id} className="main_section_area view_only">
                                <div className="main_section_header">
                                    <h6>{section?.section_no}.&nbsp;{section.section_name}</h6>
                                </div>

                                <DataTable
                                    value={section?.section_item_data}
                                    size="small"
                                    tableStyle={{ minWidth: '50rem' }}
                                    className="page_table project_table view_only p-0 p-sm-2"
                                    tableClassName="mb-1"
                                    rowClassName={getRowClassName}
                                    scrollable
                                    scrollHeight={'75vh'}
                                    emptyMessage="No data found"
                                >
                                    <Column
                                        header="Item no."
                                        alignHeader={'center'}
                                        body={(rowData: SowSectionItemData) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                        style={{ width: '8%' }}
                                        className="table_column"
                                    ></Column>

                                    <Column
                                        header="Item name"
                                        body={(rowData: SowSectionItemData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                        style={{ width: '30%' }}
                                        className="table_column"
                                    ></Column>

                                    <Column
                                        header="Unit no."
                                        body={(rowData: SowSectionItemData) => rowData.item_amount_data?.unit_no ? <span>{rowData.item_amount_data?.unit_no}</span> : '--'}
                                        alignHeader={'center'}
                                        style={{ width: '10%' }}
                                        className="table_column"
                                    ></Column>

                                    <Column
                                        header="Unit price"
                                        body={(rowData: SowSectionItemData) => rowData.item_amount_data?.unit_price ? <span>{formatPrice(rowData.item_amount_data?.unit_price)}</span> : '--'}
                                        alignHeader={'right'}
                                        style={{ width: '12%' }}
                                        className="table_column text-end"
                                    ></Column>

                                    <Column
                                        header="Sub total"
                                        body={(rowData: SowSectionItemData) => rowData.item_amount_data?.total ? <span>{formatPrice(rowData.item_amount_data?.total)}</span> : '--'}
                                        alignHeader={'right'}
                                        style={{ width: '12%' }}
                                        className="table_column text-end"
                                    ></Column>

                                    <Column
                                        header="Note"
                                        body={(rowData: SowSectionItemData) => rowData.item_amount_data?.note ? <span>{rowData.item_amount_data?.note}</span> : '--'}
                                        alignHeader={'center'}
                                        style={{ width: '28%' }}
                                        className="table_column"
                                    ></Column>
                                </DataTable>
                            </article>
                        )}
                    </React.Fragment>
                ))}

                {sowPriliminary?.length > 0 && (
                    <article id="preliminary" className="main_section_area view_only">
                        <div className="main_section_header">
                            <h6>Preliminaries</h6>
                        </div>
                        <DataTable
                            value={sowPriliminary}
                            size="small"
                            tableStyle={{ minWidth: '50rem' }}
                            className="page_table project_table view_only p-0 p-sm-2"
                            tableClassName="mb-1"
                            rowClassName={getRowClassName}
                            scrollable
                            scrollHeight={'75vh'}
                            emptyMessage="No data found"
                        >
                            <Column
                                header="Ref no."
                                alignHeader={'center'}
                                body={(rowData: Priliminary) => rowData.ref_number ? <span className="flex_center">{rowData.ref_number}</span> : '--'}
                                style={{ width: '8%' }}
                                className="table_column"
                            ></Column>

                            <Column
                                header="Item name"
                                body={(rowData: Priliminary) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                style={{ width: '30%' }}
                                className="table_column"
                            ></Column>

                            <Column
                                header="Unit no."
                                body={(rowData: Priliminary) => rowData.priliminiery_amount_data?.unit_no ? <span>{rowData.priliminiery_amount_data?.unit_no}</span> : '--'}
                                alignHeader={'center'}
                                style={{ width: '10%' }}
                                className="table_column text-center ">
                            </Column>

                            <Column
                                header="Unit price"
                                body={(rowData: Priliminary) => rowData.priliminiery_amount_data?.unit_price ? <span>{formatPrice(rowData.priliminiery_amount_data?.unit_price)}</span> : '--'}
                                alignHeader={'right'}
                                style={{ width: '12%' }}
                                className="table_column text-end"
                            ></Column>

                            <Column
                                header="sub total"
                                body={(rowData: Priliminary) => rowData.priliminiery_amount_data?.total ? <span>{formatPrice(rowData.priliminiery_amount_data?.total)}</span> : '--'}
                                alignHeader={'right'}
                                style={{ width: '12%' }}
                                className="table_column text-end"
                            ></Column>

                            <Column
                                header="Note"
                                body={(rowData: Priliminary) => rowData.priliminiery_amount_data?.note ? <span>{rowData.priliminiery_amount_data?.note}</span> : '--'}
                                alignHeader={'center'}
                                style={{ width: '28%' }}
                                className="table_column"
                            ></Column>
                        </DataTable>
                    </article>
                )}
            </div>
        </Dialog>
    )
}

export default DownloadSOW;


